import React, { useMemo } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Typography, Button, Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { FieldInput, FieldCheckbox } from '../auth/login-formik-fields';

const { Title } = Typography;
const useStyles = makeStyles(
  theme => ({
    signupText: {
      marginTop: '12px !important',
      marginBottom: '20px !important',
    },
    input: {
      marginTop: '16px !important',
    },
    title: {
      lineHeight: '38px !important',
      margin: '0 !important',
      opacity: 0.85,
    },
    backbtn: {
      marginBottom: 100,
      padding: 0,
      color: theme.colors.bodyColor,
      border: 0,
      shadow: 'none',
    },
  }),
  { name: 'SignupForEmail' },
);

const SignupAgent = ({ loginEmail, handleNextContent, handleBackEvent, loading }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const initialValues = useMemo(
    () => ({
      email: loginEmail,
      password: '',
    }),
    [loginEmail],
  );

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        email: yup
          .string()
          .label(t('email_address'))
          .email(t('landlord.auth.login.format_error.username'))
          .max(200)
          .required(t('this_part_cannot_be_empty')),
        password: yup
          .string()
          .label(t('password'))
          .min(8, t('landlord.auth.reset_password.format_error.new_password'))
          .max(100)
          .required(t('this_part_cannot_be_empty')),
      }),
    [t],
  );
  const submitEvent = e => {
    handleNextContent(e);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: submitEvent,
  });

  const handleCheckboxChange = ev => {
    formik.setFieldValue('newsletterAccepted', ev.target.checked);
  };

  return (
    <div>
      <Button ghost className={classes.backbtn} onClick={handleBackEvent}>
        <Icon type="arrow-left" />
        {t('back')}
      </Button>
      <Title level={2} className={classes.title}>
        {t('sign_up')}
      </Title>
      <Typography className={classes.signupText}>
        {t('we_will_send_you_an_email_to_verify_your_email_address')}
      </Typography>
      <FormikProvider value={formik} class>
        <FieldInput fieldConfig="email" placeholder={t('email_address')} />
        <FieldInput
          fieldConfig="password"
          type="password"
          placeholder={t('password')}
          className={classes.input}
        />
        <FieldCheckbox
          fieldConfig="newsletterAccepted"
          onChange={handleCheckboxChange}
          label={t(
            'like_to_receive_exclusive_offers_and_the_latest_info_from_student_com_by_email_or_sms',
          )}
        />
        <Button loading={loading} type="primary" size="large" onClick={formik.handleSubmit}>
          {t('create_account')}
        </Button>
      </FormikProvider>
    </div>
  );
};

SignupAgent.propTypes = {
  loginEmail: PropTypes.string.isRequired,
  handleNextContent: PropTypes.func.isRequired,
  handleBackEvent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default SignupAgent;
